import { render } from "./SectionTeacherAttendance.vue?vue&type=template&id=2b4289a0"
import script from "./SectionTeacherAttendance.vue?vue&type=script&lang=js"
export * from "./SectionTeacherAttendance.vue?vue&type=script&lang=js"

import "./SectionTeacherAttendance.vue?vue&type=style&index=0&id=2b4289a0&lang=scss"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__